import inputControl, {InputTheme} from 'amber-blocks/input-control/inputControl'
import clsx from 'clsx'
import {parseDigit, ReactInput, ReactInputProps, templateFormatter, templateParser} from 'input-format'
import {useCallback} from 'react'

import {CountryCode} from '../types'
import {useMask, useNormalize} from './hooks'
import {b} from './Input.styl'
import {trimLeadingPlus} from './utils'

const ReactInputControl = inputControl<any>(ReactInput)

type PhoneInputProps = Omit<ReactInputProps, 'format' | 'parse'> & {
  error?: string | boolean
  theme?: InputTheme
  country: CountryCode
}

const PhoneInput = ({value, className, onChange, country, ...other}: PhoneInputProps) => {
  const mask = useMask(value)
  const normalize = useNormalize()

  const handleChange = useCallback(
    (value: string) => {
      onChange(normalize(value))
    },
    [normalize, onChange],
  )
  return (
    <ReactInputControl
      {...other}
      className={clsx(b(), className)}
      dir="ltr"
      format={templateFormatter(mask as string)}
      onChange={handleChange}
      parse={templateParser(mask, parseDigit)}
      value={trimLeadingPlus(value)}
      needEvent
    />
  )
}

export default PhoneInput
